import { SfIconsNames } from './sfIconNames';
import { Box, DialogTitle, Dialog, DialogContent } from '@mui/material';
import { colors, Typography, IconButton, Tooltip } from '@sweep-io/sweep-design';
import { SfIconDescriptions } from './sfIconDescriptions';
import { useState } from 'react';
import { filterItemsBySearch } from '../../../lib/filterItemsBySearch';
import { SearchInput } from '../SearchInput';
import { SfImgIcon } from './SfImgIcon';
import RemoveIcon from './remove-icon.svg?react';
import { Close } from '@sweep-io/sweep-design/dist/icons';

const IconBox = ({
  iconName,
  onSelect,
}: {
  iconName: SfIconsNames;
  description: string;
  onSelect: (iconName: SfIconsNames) => void;
}) => {
  return (
    <Box
      sx={{
        padding: 1,
        display: 'inline-block',
        '&:hover': { backgroundColor: colors.grey[100] },
        width: '40px',
        height: '40px',
        cursor: 'pointer',
      }}
      onClick={() => onSelect(iconName)}
    >
      <SfImgIcon imageName={iconName} width="24px" height="24px" />
    </Box>
  );
};

export const SfIconsDialog = ({
  onSelect,
  open,
  onClose,
  showRemoveIcon,
  onRemove,
}: {
  onSelect: (iconName: SfIconsNames) => void;
  open: boolean;
  onClose: () => void;
  showRemoveIcon?: boolean;
  onRemove: () => void;
}) => {
  const [search, setSearch] = useState('');

  const filteredIcons = filterItemsBySearch(
    Object.entries(SfIconDescriptions),
    search,
    ([, description]) => description,
  );
  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ sx: { pb: 3, minWidth: 'auto' } }}>
      <DialogTitle sx={{ display: 'flex', flexDirection: 'column', gap: 2, pb: 1 }}>
        <Box
          sx={{ display: 'flex', flexDirection: 'row', gap: 2, justifyContent: 'space-between' }}
        >
          <Typography variant="h4">Salesforce icons</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: '6px' }}>
            {showRemoveIcon && (
              <Tooltip title="Remove icon">
                <IconButton size="tiny" variant="flat" onClick={onRemove}>
                  <RemoveIcon />
                </IconButton>
              </Tooltip>
            )}

            <IconButton size="tiny" variant="flat" onClick={onClose}>
              <Close />
            </IconButton>
          </Box>
        </Box>
        <SearchInput
          placeholder="Search all Salesforce icons"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          withFixedMagnifyingGlassIcon
          size="small"
          autoFocus
        />
        <Typography variant="caption" color={colors.grey[700]}>
          All icons
        </Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          paddingBottom: 2,
          display: 'flex',
          justifyContent: 'center',
          minWidth: 'auto',
          scrollbarGutter: 'stable both-edges',
        }}
      >
        <Box
          sx={{
            backgroundColor: 'white',
            height: '280px',
            flexWrap: 'wrap',
            flexDirection: 'row',
            width: '320px',
          }}
        >
          {filteredIcons.map(([iconName, description]) => {
            return (
              <IconBox
                key={iconName}
                iconName={iconName as SfIconsNames}
                description={description}
                onSelect={onSelect}
              />
            );
          })}
        </Box>
      </DialogContent>
    </Dialog>
  );
};
